/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneButton from 'sites/allas/components/standalone/Button';

export const DynamicStandaloneButton = StandaloneButton;
export type DynamicStandaloneButtonProps = PropsFromComponent<typeof StandaloneButton>;

export const DynamicStandaloneButtonWith = (extras: DynamicStandaloneExtras): typeof StandaloneButton => {
    return function DynamicStandaloneButton(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Button');
        return <StandaloneButton {...mergeProps({ options: { theme } }, props)} />;
    }
}